import { bindingPointPoolKeys } from 'config/functionKeysAndDisplayConfig';
import { gameTypes } from 'config/promoGameTypes';
import { prizeTypes } from 'config/promoPrizeTypes';
import { useSelector } from 'react-redux';

// 要處理的分類，有 扣點、兑點模組和 prize
export const processed_type = {
    PRIZE_TYPE: 'prizeType',
    GAME_TYPE: 'gameType',
    DEDUCTION: 'deduction'
};

export default function useGetPartnerOrSponsorPointIcon(type, data) {
    const { type: promoType } = useSelector(s => s.promo);
    const { redeemPointType = '' } = useSelector(s => s.settingPromo);
    const { pointIconUrl: partnerPointIconUrl = '' } = useSelector(s => s.partner);
    const { pointIconUrl: sponsorPointIconUrl = '' } = useSelector(s => s.sponsor);
    const settingPointSystems = useSelector(s => s.settingPointSystems);
    const qualifyWithdrawUuid = settingPointSystems?.qualifyWithdrawUuid || null;
    switch (type) {
        //對點模組 -> 要看關聯的點數池是不是會員點數 -> 如果是才可以拿 partnerPointIconUrl sponsorPointIconUrl
        case processed_type.GAME_TYPE:
            if (promoType === gameTypes.POINTS_REDEEM) {
                if (redeemPointType === bindingPointPoolKeys.MEMBER_POINT) {
                    return { partnerPointIconUrl, sponsorPointIconUrl };
                }
            }
            return { partnerPointIconUrl: '', sponsorPointIconUrl: '' };
        case processed_type.DEDUCTION:
            if (!Boolean(qualifyWithdrawUuid)) {
                return { partnerPointIconUrl, sponsorPointIconUrl };
            }
            return { partnerPointIconUrl: '', sponsorPointIconUrl: '' };
        case processed_type.PRIZE_TYPE:
            if (data.type === prizeTypes.POINT) {
                return { partnerPointIconUrl, sponsorPointIconUrl };
            }
            return { partnerPointIconUrl: '', sponsorPointIconUrl: '' };
        default:
            return { partnerPointIconUrl: '', sponsorPointIconUrl: '' };
    }
}
